import React, { useEffect } from 'react';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, notification } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { selectors, actions, hooks } from 'farmx-redux-core';
import { PageHeader } from '../components/PageHeader';
import { CardLayout } from '../components/CardLayout';
import { useTracking } from '../../../helper/mixpanel';
import resImage from '../../../assets/images/res-image.png';
import { requestImagingServicesForBlock } from '../../../helper/anomalyHelper';
import { recommendationAnomalyFilter, getRecommendationIdentifier, checkIsAllRanch } from '../../../helper/common';
import { useNavigateHome } from '../../../helper/recommendationHooks';

const {
  selectRecommendationForBlock,
  selectNewBlockById,
} = selectors;

const { setBlocks } = actions;

const { useRanchBlockSelection } = hooks;

export function SchedulingInvestigationPage() {
  const { t } = useTranslation();
  const tracking = useTracking();
  const location = useLocation();
  const history = useHistory();
  const { blockId } = useParams();
  const dispatch = useDispatch();
  const block = useSelector((state) => selectNewBlockById(state, blockId));
  const recommendation = useSelector((state) => recommendationAnomalyFilter(
    selectRecommendationForBlock(state, blockId),
  ));
  const { selectedObjFromState } = useRanchBlockSelection();
  const { selectedTab, anomaly, from } = location.state ?? {};
  const isAllRanch = checkIsAllRanch(selectedObjFromState?.type);

  // Navigate to home when ranch/block is changed
  useNavigateHome();

  useEffect(() => {
    // Set block in global block selector
    if (blockId) dispatch(setBlocks([Number(blockId)]));

    // Unmounting set block when ranch is selected
    return () => {
      if(selectedObjFromState.type === 'ranch') {
        dispatch(setBlocks([block?.ranch]));
      }
      // Unmounting block and ranch when Allranches selected
      if(isAllRanch) {
        dispatch(setBlocks([]));
      };
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blockId, dispatch, anomaly, selectedObjFromState.type, block.ranch]);

  function customOnClick(type) {
    if (type === 'investigate') {
      requestImagingServicesForBlock((success) => {
        if (success) {
          notification.success({
            message: t('Imaging services request sent successfully!'),
          });
        } else {
          notification.error({
            message: t('Imaging services request failed'),
          });
        }
      });
      if (tracking) tracking.track('Clicked Scheduling Investigate Button');
    } else if (type === 'dismiss') {
      history.push({
        pathname: `/recommendation/anomaly/detail/${getRecommendationIdentifier(recommendation)}`,
        state: { selectedTab, anomaly },
      });
      if (tracking) tracking.track('Dismissed Scheduling Investigation');
    }
  }

  return (
    <div className="page-content page-container margin-10 recommendation-container">
      <PageHeader
        showBack
        toPath={from || '/recommendation'}
        title={t('Scheduling Investigation')}
        state={{ selectedTab, anomaly }}
      />
      <CardLayout key="1">
        <div className="recommendation-detail-card1-container">
          {t('Would you like to schedule a drone scouting flight using FarmX’s scouting service?')}
        </div>
        <div className="recommendation-detail-card1-container">
          {t('This service will provide you with rich, high resolution images'
            + ' so you can better assess the condition of your crops.')}
        </div>
        <div className="recommendation-detail-card1-container">
          {`${t('Example Images')}:`}
          <img
            src={resImage}
            alt="scheduling-investigation"
            style={{ height: 'auto', maxWidth: '100%' }}
          />
        </div>
      </CardLayout>
      <div className="action-footer recommendation-detail-actions
      scheduling-investigation-button padding-bottom-10"
      >
        <Button
          size="large"
          block
          type="primary"
          onClick={() => customOnClick('investigate')}
          data-testid="investigate-button"
        >
          {t('INVESTIGATE')}
        </Button>
      </div>
    </div>
  );
}
